import translator from "@/services/translator";

export default {
  install(Vue, config) {
    const t = Vue.observable(translator);
    t.locale = config.lang;

    Vue.$trans = t.trans.bind(t);
    Vue.prototype.$translator = t;
    Vue.prototype.$trans = Vue.$trans;
    Vue.prototype.$transChoice = t.transChoice.bind(t);

    Vue.mixin({
      filters: {
        trans: Vue.prototype.$trans,
        transChoice: Vue.prototype.$transChoice,
      },
    });
  },
};
